export type BannerTone = 'goal' | 'countdown' | 'info' | 'golden' | 'end';

export class Hud {
  private spectator = false;

  setSpectator(value: boolean): void { this.spectator = value; }
  private readonly scoreA = this.getElement('#score-a');
  private readonly scoreB = this.getElement('#score-b');
  private readonly timerValue = this.getElement('#timer-value');
  private readonly clockSub = this.getElement('#clock-sub');
  private readonly statusLine = this.getElement('#status-line');
  private readonly banner = this.getElement('#banner');
  private readonly bannerMain = this.getElement('#banner-main');
  private readonly bannerSub = this.getElement('#banner-sub');
  private readonly screenTitle = this.getElement('#screen-title');
  private readonly screenEnd = this.getElement('#screen-end');
  private readonly screenPause = this.getElement('#screen-pause');
  private readonly endTitle = this.getElement('#end-title');
  private readonly endScore = this.getElement('#end-score');
  private readonly endHint = this.getElement('#end-hint');
  private readonly chipA = this.getElement('#chip-a');
  private readonly chipB = this.getElement('#chip-b');
  private readonly flashOverlay = this.getElement('#impact-flash');
  private readonly nextAttack = this.getElement('#next-attack');
  private readonly combatChain = this.getElement('#combat-chain');
  private readonly fpsCounter = this.getElement('#fps-counter');
  private lastNextAttack = '';
  private lastCombatChain = '';
  private lastTimer = '';
  private lastClockSub = '';
  private lastUrgent = false;
  private lastGolden = false;
  private lastStatus = '';
  private fpsVisible = false;

  setFpsVisible(visible: boolean): void {
    this.fpsVisible = visible;
    this.fpsCounter.toggleAttribute('hidden', !visible);
  }

  setFps(fps: number): void {
    if (this.fpsVisible) this.fpsCounter.textContent = `FPS: ${fps}`;
  }

  setCombat(next: string, chain: number): void {
    const nextAttack = `L / ¡BRUTAL! · ${next}`;
    const combatChain = chain > 1 ? `${chain} GOLPES · ${chain >= 5 ? '¡CINE ABSURDO!' : '¡QUÉ PALIZA!'}` : '';
    if (this.lastNextAttack !== nextAttack) this.nextAttack.textContent = this.lastNextAttack = nextAttack;
    if (this.lastCombatChain !== combatChain) this.combatChain.textContent = this.lastCombatChain = combatChain;
  }

  impactFlash(strength: 'soft' | 'hard'): void {
    this.flashOverlay.className = '';
    void this.flashOverlay.offsetWidth;
    this.flashOverlay.className = strength === 'hard' ? 'flash-hard' : 'flash-soft';
  }

  setScore(a: number, b: number): void {
    this.scoreA.textContent = String(a);
    this.scoreB.textContent = String(b);
  }

  setTimer(seconds: number, golden: boolean): void {
    const clamped = Math.max(0, Math.ceil(seconds));
    const minutes = Math.floor(clamped / 60).toString().padStart(2, '0');
    const secs = (clamped % 60).toString().padStart(2, '0');
    const timer = `${minutes}:${secs}`;
    const urgent = !golden && seconds <= 15;
    const clockSub = golden ? 'GOL DE ORO' : 'PARTIDO';
    if (this.lastTimer !== timer) this.timerValue.textContent = this.lastTimer = timer;
    if (this.lastUrgent !== urgent) this.timerValue.classList.toggle('urgent', this.lastUrgent = urgent);
    if (this.lastClockSub !== clockSub) this.clockSub.textContent = this.lastClockSub = clockSub;
    if (this.lastGolden !== golden) this.clockSub.classList.toggle('golden', this.lastGolden = golden);
  }

  setStatus(text: string): void {
    if (this.spectator) text = `ESPECTADOR · ${text}`;
    if (this.lastStatus !== text) this.statusLine.textContent = this.lastStatus = text;
  }

  showBanner(main: string, sub: string, tone: BannerTone): void {
    if (this.bannerMain.textContent !== main) this.bannerMain.textContent = main;
    if (this.bannerSub.textContent !== sub) this.bannerSub.textContent = sub;
    const className = `banner tone-${tone}`;
    if (this.banner.className !== className) this.banner.className = className;
  }

  hideBanner(): void {
    this.banner.className = 'banner hidden';
  }

  flashScore(team: 'A' | 'B'): void {
    const chip = team === 'A' ? this.chipA : this.chipB;
    chip.classList.remove('flash');
    void chip.offsetWidth;
    chip.classList.add('flash');
  }

  showTitle(show: boolean): void {
    this.screenTitle.classList.toggle('hidden', !show);
  }

  showPause(show: boolean): void {
    this.screenPause.classList.toggle('hidden', !show);
  }

  showEnd(title: string, score: string, hint: string): void {
    this.endTitle.textContent = title;
    this.endScore.textContent = score;
    this.endHint.textContent = hint;
    this.screenEnd.classList.remove('hidden');
  }

  hideEnd(): void {
    this.screenEnd.classList.add('hidden');
  }

  private getElement(selector: string): HTMLElement {
    const element = document.querySelector<HTMLElement>(selector);
    if (!element) throw new Error(`Missing HUD element: ${selector}`);
    return element;
  }
}
